import Tamilvanan from "../images/tamilvanan.png";
import Karan from "../images/karan.png";
var Tofollow = [
    {
        name: 'Tamil Vanan',
        username: "@tamilvanan",
        profile: Tamilvanan

    }, {
        name: 'Karan',
        username: "@karan",
        profile: Karan

    },
    {

        Show: "Show More"
    }
]

export default Tofollow;